<template>
  <v-card-title class="cerrar">
    <p><strong>{{titulo}}</strong></p>
    <v-spacer> </v-spacer>
    <button @click="$emit('cerrar')" v-if="mostrarCerrar" class="hvr hvr-scale"><img src="../assets/imagenes_compartidas/cerrar_blan.png" alt="botón cerrar"></button>
  </v-card-title>
</template>
<script>
export default {
    props: {
      titulo: {
        type: String,
        default: '',
        required: false
      },
      mostrarCerrar: {
        type: Boolean,
        default: true,
        required:false
      }
    }
}
</script>

<style lang="scss" scoped>
.cerrar {
  padding: 10px;
  padding-bottom: 0;
  max-height: 50px;
  // background-color: #CCEB81;
  background-image: url("../assets/textura-M1.png");
  background-repeat: repeat-x;
  img{
    width: 30px;
    padding:5px;
    background: #004636;
    border-radius: 45px;
  }
}
</style>